import { GUESTS_SATISFACTION_COMPARATOR_ADD_COMPARATOR, GUESTS_SATISFACTION_COMPARATOR_REMOVE_COMPARATOR } from './actionTypes'
import { GUESTS_SATISFACTION_COMPARATOR_SET_REGION, GUESTS_SATISFACTION_COMPARATOR_SET_DATA_TYPE } from './actionTypes'

export function guestsSatisfactionAddComparator() { return { type: GUESTS_SATISFACTION_COMPARATOR_ADD_COMPARATOR }};
export function guestsSatisfactionRemoveComparator() { return { type: GUESTS_SATISFACTION_COMPARATOR_REMOVE_COMPARATOR }};

export function guestsSatisfactionSetRegion(comparatorIndex, region) { return { type: GUESTS_SATISFACTION_COMPARATOR_SET_REGION, comparatorIndex, region }};
export function guestsSatisfactionSetDataType(comparatorIndex, dataType) { return { type: GUESTS_SATISFACTION_COMPARATOR_SET_DATA_TYPE, comparatorIndex, dataType }};


// WEBPACK FOOTER //
// ./src/actions/guestsSatisfactionComparator.js